import { CopyOutlined } from "@ant-design/icons"
import { formatBlockchainAddress } from "../../backend/helpers/formatBlockchainAddress.ts"
import { CurrenciesType, MoneyFlowStateWithPrice } from "../../backend/types/moneyflow.ts"
import { ColumnFilterItem } from "antd/es/table/interface"
import { ReactNode, PropsWithChildren } from "react"
import { Panels } from "../../utils/constants.ts"
import { BlockchainNetwork } from "../../backend/constants.ts"
import { getBitqueryExplorerUrl } from "../../backend/helpers/explorerUrl.ts"
import { instantMoneyflowPath, isTraceableAddress } from "../../utils/instantMoneyflow.ts"

export const ROW_HEIGHT_WITH_HOLDINGS = 61
export const ENV_HEIGHT = 200

export enum TransactionTableTabs {
    ALL = 'all',
    INBOUND = 'inbound',
    OUTBOUND = 'outbound',
    BY_CURRENCY = 'bycurrency'
}

export type PaginatedTxsWithPriceType = {
    txs: MoneyFlowStateWithPrice[]
    total: number
    currencies: CurrenciesType[]
}

export type TransactionsTableProps = {
    direction?: 'inbound' | 'outbound' | undefined
}
export type GridCardProps = {
    id: Panels,
    title?: string | ReactNode,
    fullSize: boolean,
    toggleFullSize: (panelId: Panels) => void
} & PropsWithChildren

// A transaction hash links to the explorer; an address opens a MoneyFlow for
// it on the flow's network (given as `network`)
export const txNode = (
    value: string,
    record: MoneyFlowStateWithPrice,
    onClick: (value: string) => void,
    isHash: boolean = false,
    network?: string
) => <>
    {isHash || !network ?
        <a
            target="_blank"
            href={getBitqueryExplorerUrl(record.blockchain_network as BlockchainNetwork, isHash ? 'tx' : 'address', value)}>
            {formatBlockchainAddress(value)}
        </a> :
        isTraceableAddress(value) ?
            <a target="_blank" href={instantMoneyflowPath(network, value)} title='Open a MoneyFlow for this address'>
                {formatBlockchainAddress(value)}
            </a> :
            formatBlockchainAddress(value)}
    <CopyOutlined style={{ marginLeft: '.5em', opacity: 0.73, cursor: 'pointer' }}
        onClick={() => onClick(value)}
    />
</>

export const getUniqueListBy = (
    arr: ColumnFilterItem[] | undefined,
    key: keyof ColumnFilterItem
): ColumnFilterItem[] | undefined =>
    (arr ? [...new Map(arr.map((item) => [item[key], item])).values()] as ColumnFilterItem[] : undefined)
